import type { IUserPlanPreferences } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import Preferences from '@/creditflowresearch/domain/Preferences';
import MarketOverviewUrlBuilder from '@/creditflowresearch/application/Preferences/MarketOverviewUrlBuilder';
import MarketOverviewUrlResolver from '@/creditflowresearch/infrastructure/routing/MarketOverviewUrlResolver';
import {
  canAccessItem,
  preferenceItems,
  resolveAccessiblePreferences,
} from '@/creditflowresearch/application/hooks/userPreferences/helpers';

interface IAccessibleMarketOverviewUrlParams {
  preferences: IUserPlanPreferences,
  products?: string[],
  regions?: string[],
}

/**
 * Landing URL for the user's default page. Saved preferences are reconciled against the
 * plan first, so a product the user has lost access to never becomes the redirect target
 * — the same fallback the preference menu shows applies here (ABS locked -> HYC).
 */
const buildAccessibleMarketOverviewUrl = ({
  preferences,
  products = [],
  regions = [],
}: IAccessibleMarketOverviewUrlParams): string | null => {
  const accessiblePreferences = resolveAccessiblePreferences(
    preferenceItems,
    preferences,
    (item) => canAccessItem(item, products, regions),
  );
  const urlBuilder = new MarketOverviewUrlBuilder(new MarketOverviewUrlResolver());

  return urlBuilder.build(new Preferences(accessiblePreferences));
};

export default buildAccessibleMarketOverviewUrl;
